import React from "react";
import logoFooter from "../../Assets/Image/logo_withoutBG.png";
import { Link } from "react-router-dom";
import "./Footer.css";

export default function Footer() {
  return (
    <>
      <div className="footer pt-2 bg-black ">
        <div className="container w-75  py-3 d-flex">
          <div className="leftFooter w-75">
            <div className="logoFooter">
              <Link className="navbar-brand" to="/">
                <img src={logoFooter} alt="Logo Footer" width={150} />
              </Link>
            </div>
            <p className="fs-6 fw-400 text-white">
              Welcome to Vehex, your trusted partner for quality auto parts and
              premium service. We are passionate about helping car enthusiasts
              and everyday drivers keep their vehicles running at their best and
              looking great. With Vehex, your journey is our priority. Join us
              to achieve excellence in the automotive world.
            </p>
            <div className="socialIcons d-flex gap-3 my-4">

              <a href="https://www.instagram.com/vehex_?igsh=MXB4dTk5c2NnaDk4cA==">
                <div>
                  <i class="fa-brands fa-instagram fs-5 main-color"></i>
                </div>
              </a>

              <a href="https://x.com/vehex_?s=21&t=rNlwdd5svQFWKykuQNj4Zg">
              <div>
                <i class="fa-brands fa-x-twitter fs-5 main-color"></i>
              </div>
              </a>

              <a href="https://wa.me/+966506330295">
              <div>
                <i class="fa-brands fa-whatsapp fs-5 main-color"></i>
              </div>
              </a>


            </div>
          </div>
          <div className="rightFooter w-25">
            <h3 className="main-color mb-3 fw-500 heading">QUICK LINKS</h3>
            <ul className="m-0 p-0">
              <li className="fs-6">
                <Link to="addVehicle">Add vehicle</Link>
              </li>
              <li className="fs-6">
                <Link to="products">Products</Link>
              </li>
              <li className="fs-6">
                <Link to="about">About Us</Link>
              </li>
              <li className="fs-6">
                <Link to="contact">Contact</Link>
              </li>
              <li className="fs-6">
                <Link to="howtoorder">How to Order</Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="container w-75 copyright d-flex align-items-center justify-content-center py-3">
          <p className="fs-6 text-center fw-400 text-white m-0 ">
            &copy; Copyright 2024 reserved to
            <span className="second-color fw-bold"> VEHEX</span> &
            <a href="https://wa.me/+966548720537" class="fw-bold second-color"> IT.RENADMADI</a>
          </p>
        </div>
      </div>
    </>
  );
}
